import "./footer.css";

function Footer() {
    return (
        <footer className="footer">
            <p>Made with ♥︎ (and React)</p>
            <p>© 2026 Heather Carminati.</p>
        </footer>
    );
}

export default Footer;